module.exports = __webpack_public_path__ + "static/media/upload_icon.289d05c9.gif";